// 算力资源规格列表
export const resList =
    [
        {
            id: 91001,
            title: "NVIDIA H200 - 141G (NVLink)",
            tag: "智算",
            region: "哈密",
            hotSale: 1,
            configuration: {
                cpu: {
                    model: "2 * Intel Xeon Platinum 8468 48核心 @2.1GHz",
                    memory: "2 TB",
                },
                gpu: {
                    model: "8 * NVIDIA Hopper H200 NVLink",
                    memory: "141GB (900GB/s)",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "0.64 PB 具有EC冗余的全闪分布式存储，写速率50GB/s，读速率100GB/s",
            network: {
                computeNetwork: "400G IB 无阻塞",
                storageNetwork: "200G IB 无阻塞",
                businessNetwork: "10G 以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "6.5万 /月",
        },
        {
            id: 91002,
            title: "NVIDIA RTX 3090 - 24GB",
            tag: "智算",
            region: "哈密",
            hotSale: 1,
            configuration: {
                cpu: {
                    model: "2 * Intel Xeon Gold 5220R @2.20GHz",
                    memory: "512 GB",
                },
                gpu: {
                    model: "8 * NVIDIA RTX 3090 PCIe",
                    memory: "24GB (936 GB/s)",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "高速分布式存储的规格描述",
            network: {
                storageNetwork: "200G IB",
                businessNetwork: "10G以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "5000 /月",
        },
        {
            id: 93003,
            title: "NVIDIA RTX 4090 - 24GB",
            tag: "智算",
            region: "广州",
            hotSale: 1,
            configuration: {
                cpu: {
                    model: "2 * Intel Xeon Gold 5220R @2.20GHz",
                    memory: "512 GB",
                },
                gpu: {
                    model: "8 * NVIDIA RTX 4090",
                    memory: "24GB (936 GB/s)",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "高速分布式存储的规格描述",
            network: {
                storageNetwork: "200G IB",
                businessNetwork: "10G以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "1万 /月",
        },
        {
            id: 91004,
            title: "NVIDIA RTX 3080-10GB",
            tag: "智算",
            region: "哈密",
            hotSale: 1,
            configuration: {
                cpu: {
                    model: "2 * Intel Xeon Gold 5220R @2.20GHz",
                    memory: "512 GB",
                },
                gpu: {
                    model: "8 * NVIDIA RTX 3080 PCIe",
                    memory: "10GB",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "0.64 PB 具有EC冗余的全闪分布式存储，写速率50GB/s，读速率100GB/s",
            network: {
                computeNetwork: "",
                storageNetwork: "200G IB",
                businessNetwork: "10G以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "2500 /月",
        },
        {
            id: 92005,
            title: "NVIDIA A100-80G (NVLink)",
            tag: "智算",
            region: "乌兰察布",
            hotSale: 0,
            configuration: {
                cpu: {
                    model: "2 * Intel Xeon Platinum 8468 48核心 @2.1GHz",
                    memory: "2 TB",
                },
                gpu: {
                    model: "8 * NVIDIA Ampere A100 NVLink",
                    memory: "80GB (900GB/s)",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "0.64 PB 具有EC冗余的全闪分布式存储，写速率50GB/s，读速率100GB/s",
            network: {
                computeNetwork: "400G IB 无阻塞",
                storageNetwork: "200G IB 无阻塞",
                businessNetwork: "10G 以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "3.7 万/月",
        },
        {
            id: 92006,
            title: "NVIDIA A100-80G (PCIe)",
            tag: "智算",
            region: "乌兰察布",
            hotSale: 0,
            configuration: {
                cpu: {
                    model: "2 * Intel Xeon Platinum 8468 48核心 @2.1GHz",
                    memory: "2 TB",
                },
                gpu: {
                    model: "8 * NVIDIA Ampere A100 NVLink",
                    memory: "80GB (900GB/s)",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "0.64 PB 具有EC冗余的全闪分布式存储，写速率50GB/s，读速率100GB/s",
            network: {
                computeNetwork: "",
                storageNetwork: "200G IB 无阻塞",
                businessNetwork: "10G 以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "3.5 万/月",
        },

        {
            id: 101,
            title: "Intel Xeon CPU Max 9462",
            tag: "超算",
            region: "哈密",
            configuration: {
                cpu: {
                    model: "Intel Xeon CPU Max 9462 32核 @3.50 GHz",
                    memory: "512GB",
                },

                pcieCommunication: "双向 128 GB/s",
            },
            storage: "1 PB 具有EC冗余的高性能分布式存储",
            network: {
                storageNetwork: "200G IB",
                businessNetwork: "10G以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "0.5 /核时",
        },
        {
            id: 201,
            title: "x86服务器",
            tag: "通算",
            region: "哈密",
            configuration: {
                cpu: {
                    model: "Intel Xeon CPU Max 9462 @ 2.70GHz",
                    memory: "512GB",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "160 TB 具有EC冗余的高性能分布式存储",
            network: {
                storageNetwork: "200G IB",
                businessNetwork: "10G高速网络",
                internetAccess:"千兆互联网接入",
            },
            price: "2200 /月",
        },
        {
            id: 202,
            title: "Ampere Altra ARM服务器",
            tag: "通算",
            region: "哈密",
            configuration: {
                cpu: {
                    model: "Ampere Altra Q64-30 64核ARM处理器 @ 2.8GHz",
                    memory: "512GB",
                },
                pcieCommunication: "双向 128 GB/s",
            },
            storage: "160 TB 具有EC冗余的高性能分布式存储",
            network: {
                storageNetwork: "10G高速网络",
                businessNetwork: "10G以太网",
                internetAccess:"千兆互联网接入",
            },
            price: "2000 /月",
        },
    ]

export const deliveryModes = [
    {
        title: "智算-裸金属节点/集群",
        description: "包年包月",
        scenario: "较大规模的模型训练或推理服务场景。",
        details:
            "用户独占若干台物理服务器资源；可通过云平台提供的WebSSH或通过Xshell、putty等客户端访问和操作服务器；可挂载分布式存储；可配置专用虚拟网络；可按照用户需要部署指定的操作系统。",
    },
    {
        title: "智算-容器云服务",
        description: "按量计费",
        descriptionUnit: "",
        scenario: "多用户共用的AI/机器学习研发、训练、测试、部署场景。",
        details:
            "为用户提供便捷易用的AI/机器学习加速开发平台，提供基于Jupyter/VSCode的模型算法开发环境、高效易用的多机多卡模型训练任务管理和推理服务管理、环境镜像管理、模型管理、数据集管理等功能；提供用户间的私有数据隔离和公共数据共享。",
    },
    {
        title: "大模型API调用",
        description: "按token计费",
        scenario: "大模型应用对大模型算力调用。",
        details:
            "提供了符合OpenAPI规范的标准化接口，使得客户能够轻松地与平台上的多种大模型服务对接。提供包括满血版DeepSeek在内的多种常用大模型的推理服务调用接口。",
    },
    {
        title: "超算节点/集群",
        description: "包年包月",
        descriptionUnit: "",
        scenario: "高定制化要求的高性能计算场景。",
        details:
            "用户独占专属超算服务器。裸金属服务非常适合需要处理大量敏感数据或运行高性能计算任务的用户。用户可根据自己的需求自由配置操作系统、超算调度软件及超算应用软件，享受如同本地部署般的灵活性与控制力。",
    },
    {
        title: "超算平台机时服务",
        description: "按量计费",
        descriptionUnit: "",
        scenario: "追求高效、易用的通用的高性能计算场景。",
        details:
            "快速接入并利用超算资源，无需关心底层硬件维护，根据实际使用的计算时长付费。我们提供了强大的超算管理平台，支持一键式资源调度、作业提交与监控等功能，兼容多种主流科学计算软件，降低了用户的迁移成本和技术门槛。",
    },
    {
        title: "通算-裸金属节点/集群",
        description: "包年包月/按量计费",
        descriptionUnit: "",
        scenario: "关注性能与数据安全的应用与大数据服务部署。",
        details:
            "用户独占专属裸金属节点，通过快速部署工具和全天候技术支持，帮助客户轻松上线并高效管理其应用，满足业务需求的同时保证运行的稳定性和安全性。支持以包年包月方式或按量计费方式进行结算。",
    },
    {
        title: "通算-云主机",
        description: "按量计费/包年包月",
        descriptionUnit: "",
        scenario: "应用部署、开发与测试。",
        details:
            "提供基于x86和ARM的多种处理器的云主机服务。通过简便快捷的资源配置与管理工具，客户能够迅速启动并调整其云主机实例，同时享有全面的技术支持和高可靠性保障，确保业务的连续性和灵活性。用户可根据自身业务特点灵活选择包年包月或按量计费的结算方式。",
    },
]

export const resRecommendations = [
    {
        title: "DeepSeek R1满血版推理服务",
        description: "DeepSeek R1满血版推理服务描述",
        details:
            "若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务",
    },
    {
        title: "DeepSeek R1满血版推理服务",
        description: "DeepSeek R1满血版推理服务描述",
        details:
            "若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务",
    },
    {
        title: "DeepSeek R1满血版推理服务",
        description: "DeepSeek R1满血版推理服务描述",
        details:
            "若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务",
    },
    {
        title: "DeepSeek R1满血版推理服务",
        description: "DeepSeek R1满血版推理服务描述",
        details:
            "若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务用户独享若千合裸金属服务",
    },
]

